import axios from 'axios';

export function authHeaders() {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
}

export const consultationApi = {
  getTypes: () => axios.get('/api/consultations/types', { headers: authHeaders() }),

  getAvailability: (advocateId, { type = 'video', duration = 30, days = 14 } = {}) =>
    axios.get(`/api/consultations/${type}/availability/${advocateId}`, {
      headers: authHeaders(),
      params: { duration, days },
    }),

  createBooking: (payload, type = 'video') =>
    axios.post(`/api/consultations/${type}/bookings`, payload, { headers: authHeaders() }),

  createPaymentOrder: (bookingId) =>
    axios.post(`/api/consultations/bookings/${bookingId}/payment/order`, {}, { headers: authHeaders() }),

  verifyPayment: (bookingId, payload) =>
    axios.post(`/api/consultations/bookings/${bookingId}/payment/verify`, payload, { headers: authHeaders() }),

  confirmInternalPayment: (bookingId) =>
    axios.post(`/api/consultations/bookings/${bookingId}/payment/confirm-internal`, {}, { headers: authHeaders() }),

  getMyBookings: (type = 'video') =>
    axios.get('/api/consultations/mine', { headers: authHeaders(), params: { type } }),

  getAdvocateBookings: (type = 'video') =>
    axios.get('/api/consultations/advocate', { headers: authHeaders(), params: { type } }),

  getBooking: (id) =>
    axios.get(`/api/consultations/bookings/${id}`, { headers: authHeaders() }),

  acceptBooking: (id) =>
    axios.post(`/api/consultations/bookings/${id}/accept`, {}, { headers: authHeaders() }),

  rejectBooking: (id, reason) =>
    axios.post(`/api/consultations/bookings/${id}/reject`, { reason }, { headers: authHeaders() }),

  cancelBooking: (id, reason) =>
    axios.post(`/api/consultations/bookings/${id}/cancel`, { reason }, { headers: authHeaders() }),

  completeBooking: (id) =>
    axios.post(`/api/consultations/bookings/${id}/complete`, {}, { headers: authHeaders() }),

  joinBooking: (id) =>
    axios.get(`/api/consultations/bookings/${id}/join`, { headers: authHeaders() }),

  getSettings: (type = 'video') =>
    axios.get('/api/consultations/settings', { headers: authHeaders(), params: { type } }),

  saveSettings: (payload) =>
    axios.put('/api/consultations/settings', payload, { headers: authHeaders() }),

  // Call lifecycle
  startCall: (id) =>
    axios.post(`/api/consultations/bookings/${id}/call/start`, {}, { headers: authHeaders() }),

  answerCall: (id) =>
    axios.post(`/api/consultations/bookings/${id}/call/answer`, {}, { headers: authHeaders() }),

  declineCall: (id, reason) =>
    axios.post(`/api/consultations/bookings/${id}/call/decline`, { reason }, { headers: authHeaders() }),

  cancelCall: (id) =>
    axios.post(`/api/consultations/bookings/${id}/call/cancel`, {}, { headers: authHeaders() }),

  getCallState: (id) =>
    axios.get(`/api/consultations/bookings/${id}/call/state`, { headers: authHeaders() }),
};

export const notificationApi = {
  list: (limit = 30) =>
    axios.get('/api/notifications', { headers: authHeaders(), params: { limit } }),

  unreadCount: () =>
    axios.get('/api/notifications/unread-count', { headers: authHeaders() }),

  markRead: (id) =>
    axios.post(`/api/notifications/${id}/read`, {}, { headers: authHeaders() }),

  markAllRead: () =>
    axios.post('/api/notifications/read-all', {}, { headers: authHeaders() }),

  getVapidKey: () =>
    axios.get('/api/notifications/vapid-public-key', { headers: authHeaders() }),

  subscribePush: (subscription) =>
    axios.post('/api/notifications/push/subscribe', { subscription }, { headers: authHeaders() }),

  unsubscribePush: (endpoint) =>
    axios.post('/api/notifications/push/unsubscribe', { endpoint }, { headers: authHeaders() }),
};

export function formatFee(amount, currency = 'INR') {
  const value = Number(amount) || 0;
  try {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency, maximumFractionDigits: 0 }).format(value);
  } catch {
    return `${currency} ${value}`;
  }
}

export function formatConsultDate(iso, timezone) {
  if (!iso) return '—';
  const date = new Date(iso);
  return new Intl.DateTimeFormat('en-IN', {
    timeZone: timezone || undefined,
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date);
}

export const STATUS_LABELS = {
  pending: 'Pending',
  paid: 'Paid',
  confirmed: 'Confirmed',
  upcoming: 'Upcoming',
  in_progress: 'In Progress',
  completed: 'Completed',
  cancelled: 'Cancelled',
  no_show: 'No Show',
  unpaid: 'Unpaid',
  waived: 'Waived',
  refunded: 'Refunded',
  failed: 'Failed',
};

export function statusLabel(status) {
  return STATUS_LABELS[status] || status;
}
